"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Share = function Share(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M8 13.5C8.82843 13.5 9.5 12.8284 9.5 12C9.5 11.1716 8.82843 10.5 8 10.5C7.17157 10.5 6.5 11.1716 6.5 12C6.5 12.8284 7.17157 13.5 8 13.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("g", {
    opacity: "0.5"
  }, _react.default.createElement("path", {
    opacity: "0.5",
    d: "M9.04024 10.9207C9.28764 11.1586 9.44578 11.4742 9.48815 11.8148L14.9597 9.07903C15.2152 9.32544 15.5495 9.47358 15.9036 9.49727C16.2577 9.52095 16.6088 9.41865 16.8947 9.20844C17.1807 8.99824 17.3831 8.69368 17.4662 8.34864C17.5492 8.00359 17.5076 7.64029 17.3486 7.32298C17.1896 7.00567 16.9236 6.75481 16.5975 6.61475C16.2714 6.47469 15.9063 6.45446 15.5667 6.55764C15.2271 6.66082 14.935 6.88077 14.7419 7.17857C14.5489 7.47638 14.4674 7.83286 14.5118 8.18497L9.04024 10.9207Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 14.5C15.6117 14.4998 15.2387 14.6508 14.9597 14.9208L9.48815 12.1851C9.44578 12.5256 9.28765 12.8413 9.04024 13.0792L14.5118 15.8149C14.4743 16.1172 14.5296 16.4236 14.6705 16.6936C14.8114 16.9636 15.0311 17.1843 15.3005 17.3264C15.5699 17.4685 15.8761 17.5252 16.1785 17.489C16.4809 17.4528 16.7651 17.3254 16.9933 17.1237C17.2215 16.9221 17.3829 16.6557 17.4561 16.3601C17.5292 16.0645 17.5107 15.7536 17.4028 15.4688C17.295 15.184 17.103 14.9387 16.8525 14.7657C16.6019 14.5926 16.3045 14.5 16 14.5Z",
    fill: props.foregroundColor
  })));
};

Share.defaultProps = {
  altText: "Share",
  backgroundColor: "#212121",
  foregroundColor: "#FFFFFF"
};
Share.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Share;
exports.default = _default;